module.exports = __webpack_public_path__ + "static/media/photographer.2c33710a.jpg";